import { mapNamedLocaleToLocale } from 'data/localsMap';

const { envVars } = require('next/config').default().publicRuntimeConfig;

const { EN_DOMAIN } = envVars;
const { API_PROTOCOL } = envVars;

const generateSlugsHrefLangs = (url, bikeSlugs, bikeId = '', pageNumber = null) => {
  const urls = [];
  Object.entries(mapNamedLocaleToLocale).forEach(([namedLocale, standardLocale]) => {
    let localizedUrl = `${API_PROTOCOL}://${EN_DOMAIN}${namedLocale !== 'en' ? `/${namedLocale}` : ''}`;
    // eslint-disable-next-line no-unused-vars
    Object.entries(bikeSlugs).forEach(([_, bikeSlug]) => {
      if (!bikeSlug) return;
      let slugTranslation = bikeSlug?.slug_translations.find((item) => item.locale === standardLocale);
      if (!slugTranslation) {
        slugTranslation = bikeSlug?.slug_translations.find(
          (item) => item.locale === 'en',
        ) || { slug: bikeSlug?.slug };
      }
      localizedUrl += `/${slugTranslation?.slug}`;
    });

    localizedUrl += pageNumber && pageNumber > 1 ? `?page=${pageNumber}` : '';
    urls.push({
      url: `${localizedUrl}${bikeId}`,
      hreflang: standardLocale === 'en' ? 'x-default' : standardLocale,
    });
  });

  return {
    canonical: `${API_PROTOCOL}://${EN_DOMAIN}${url}`,
    urls,
  };
};

export default generateSlugsHrefLangs;
